var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 32,
    viewBox: "0 0 72 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_904_3283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 0H0V32H72V0Z",
    fill: "#333F48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0755 11.9876L36.905 16.1057L41.0755 20.2429L39.9096 21.391L35.7136 17.2789L31.5446 21.3836L30.3562 20.2119L34.5282 16.1057L30.3562 12.0098L31.5446 10.8381L35.7166 14.9236L39.8871 10.8159L41.0755 11.9876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4084 5.01953H45.6015V26.9794H51.4084V5.01953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6176 5.01953H56.8107V26.9794H62.6176V5.01953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1476 5.01953H9.3407V26.9794H15.1476V5.01953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3568 5.01953H20.5499V26.9794H26.3568V5.01953Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_904_3283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ae395b8fc258e641c68936c647828bf8.svg";
export { ForwardRef as ReactComponent };